import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { type Editor } from "@tiptap/react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 날짜 변환 함수
export function formatDate(dateString: string) {
  // dateString이 유효한지 확인
  if (!dateString) {
    return new Date().toISOString().split("T")[0]; // 현재 날짜 반환
  }
  
  const date = new Date(dateString);
  
  // Invalid Date인지 확인
  if (isNaN(date.getTime())) {
    return new Date().toISOString().split("T")[0]; // 현재 날짜 반환
  }
  
  return date.toISOString().split("T")[0]; // YYYY-MM-DD 형식으로 변환
}

// 토큰 계산
export function countMoney(usage, price) {
  const EX_RATE = 1430;
  const inputMoney = ((price.input * EX_RATE) / 1000000) * usage.inputTokens;

  const outputMoney =
    ((price.output * EX_RATE) / 1000000) * usage.outputTokens;

  // 요청 건당 비용 계산 (1000건당 비용 기준)
  let requestMoney = 0;
  if (price.per && typeof price.per === "number" && price.per > 0) {
    requestMoney = (price.per / 1000) * EX_RATE;
  }

  const totalMoney = inputMoney + outputMoney + requestMoney;

  return {
    inputToken: usage.inputTokens,
    outputToken: usage.outputTokens,
    inputMoney: inputMoney,
    outputMoney: outputMoney,
    requestMoney: requestMoney,
    totalMoney: totalMoney,
  };
}

// util/sleep.ts
export function sleep(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

export function fetchSelectionLength(editor: Editor) {
  const { state } = editor.view;
  const { from, to } = state.selection;
  const fullDoc = state.doc;
  const length = fullDoc.textBetween(from, to).trim().length;
  return length;
}
